import { InfoTooltip } from '../InfoTooltip.js';
import { METRIC_EXPLANATIONS } from '../../data/metric-explanations.js';

export interface HolderIntelData {
  holderCount: number | null;
  holderRiskLevel: string | null;
  dataUnavailableReason?: string;
}

const NO_DATA = 'No data available yet';

export function HolderIntelPanel({ data }: { data: HolderIntelData | null | undefined }) {
  const d = data ?? null;

  if (!d) return null;

  if (d.dataUnavailableReason) {
    return (
      <div className="dash-card ws-forensic-section">
        <h3 className="ws-forensic-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          Holder Intelligence
          <InfoTooltip explain={METRIC_EXPLANATIONS.holders} compact />
        </h3>
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Holder Data</span>
            <span className="intel-metric-value" style={{ fontSize: '0.85rem' }}>
              {d.dataUnavailableReason}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dash-card ws-forensic-section">
      <h3 className="ws-forensic-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        Holder Intelligence
        <InfoTooltip explain={METRIC_EXPLANATIONS.holders} compact />
      </h3>
      <div className="intel-grid intel-grid-2">
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">
              Total Holders
              <InfoTooltip explain={METRIC_EXPLANATIONS.holders} compact />
            </span>
            <span className="intel-metric-value">
              {d.holderCount != null ? d.holderCount.toLocaleString('en-US') : NO_DATA}
            </span>
          </div>
        </div>
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Risk Assessment</span>
            {d.holderRiskLevel ? (
              <span className={`intel-bool-badge ${d.holderRiskLevel === 'LOW' ? 'intel-bool-good' : 'intel-bool-bad'}`}>
                {d.holderRiskLevel === 'LOW' ? 'Low Risk Indicators' : d.holderRiskLevel === 'HIGH' ? 'Severe Risk Indicators' : 'Moderate Risk Indicators'}
              </span>
            ) : (
              <span className="intel-metric-value">{NO_DATA}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
